import React from 'react';

import DataContainer from 'Components/UI/DataContainer';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import LogDifferences from './LogDifferences';

const Container = () => {
  const { relationshipCollection, isInitializing } = useIncludedRelationshipContext();

  return (
    <DataContainer
      loading={isInitializing}
      component={LogDifferences}
      componentProps={{
        collection: relationshipCollection,
      }}
    />
  );
};

export default Container;
